export { SentimentNegativeIcon } from './sentiment-negative-icon';
